import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { HubspotProvider } from "@aaronhayes/react-use-hubspot-form";
import Header from "./header";
import Footer from "./footer";
import Cookies from "../policyCookies";
import "./index.css";

const Main = styled.main`
  padding: 0;
  padding-top: ${({ fixedHeader }) => (fixedHeader ? "90px" : 0)};
  @media screen and (max-width: 875px) {
    padding-top: ${({ fixedHeader }) => (fixedHeader ? "87px" : 0)};
  }
`;

const Layout = ({
  children,
  footer = "Want to start your project?",
  fixedHeader = true,
}) => (
  <HubspotProvider>
    <Header />
    <Main fixedHeader={fixedHeader}>{children}</Main>
    <Cookies />
    <Footer footH3={footer}></Footer>
  </HubspotProvider>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  fixedHeader: PropTypes.bool,
};

export default Layout;
